import { Tooltip } from "antd";
import { useAuth } from "../providers/AuthProvider";

// This component shows a tooltip if the auth can manage clients

const TalentDisplayName = ({ talent, children }) => {
    const { auth } = useAuth();

    if (auth.canManageClients()) {
        return (
            <Tooltip
                placement="top"
                color="#000"
                // title={talent.displayName(auth)}
                title={talent.fullName()}
            >
                {children || <p>{talent?.firstNamePlusInitial()}</p>}
            </Tooltip>
        )
    }

    return children || <p>{talent?.firstNamePlusInitial()}</p>
}

export default TalentDisplayName;

// USAGE: -> children take priority

// <TalentDisplayName talent={talent} />

// <TalentDisplayName talent={talent}>
//     <p classname="text-xl text-primary">
//         {talent.firstNamePlusInitial()}
//     </p>
// </TalentDisplayName>